<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Mission - Historique - Decret d'érection " />
            <MIssionHisto />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import MIssionHisto from '../Mission/MissionHisto.vue'


export default {
    name: 'BenevolePage',
    components: {
        NavBar,
        PageTitle,
        MIssionHisto,
        FooterComp,
    }
}
</script>